module.exports = __webpack_public_path__ + "static/media/XP44-logo.1c5e531b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/XP44/XP44-logo.svg
// module id = 502
// module chunks = 0